var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraduate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_dd_468_10221)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_468_10221",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 25C5 11.7452 15.7452 1 29 1C42.2548 1 53 11.7452 53 25C53 38.2548 42.2548 49 29 49C15.7452 49 5 38.2548 5 25Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5 25C5 11.7452 15.7452 1 29 1C42.2548 1 53 11.7452 53 25C53 38.2548 42.2548 49 29 49C15.7452 49 5 38.2548 5 25Z",
    fill: "url(#paint0_linear_468_10221)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 25M53 25M53 25M5 25M29 1M53 25M29 49M5 25M29 49V47C16.8497 47 7 37.1503 7 25H5H3C3 39.3594 14.6406 51 29 51V49ZM53 25H51C51 37.1503 41.1503 47 29 47V49V51C43.3594 51 55 39.3594 55 25H53ZM29 1V3C41.1503 3 51 12.8497 51 25H53H55C55 10.6406 43.3594 -1 29 -1V1ZM29 1V-1C14.6406 -1 3 10.6406 3 25H5H7C7 12.8497 16.8497 3 29 3V1Z",
    fill: "white",
    mask: "url(#path-1-inside-1_468_10221)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_468_10221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.8501 24.1016C36.9993 24.0357 37.1259 23.9276 37.2142 23.7906C37.3025 23.6535 37.3487 23.4935 37.347 23.3305C37.3453 23.1675 37.2958 23.0085 37.2047 22.8733C37.1136 22.7381 36.9848 22.6326 36.8342 22.5699L29.6917 19.3166C29.4746 19.2175 29.2387 19.1663 29.0001 19.1663C28.7614 19.1663 28.5255 19.2175 28.3084 19.3166L21.1667 22.5666C21.0184 22.6315 20.8922 22.7383 20.8035 22.8739C20.7149 23.0095 20.6677 23.1679 20.6677 23.3299C20.6677 23.4919 20.7149 23.6503 20.8035 23.7859C20.8922 23.9214 21.0184 24.0282 21.1667 24.0932L28.3084 27.3499C28.5255 27.4489 28.7614 27.5002 29.0001 27.5002C29.2387 27.5002 29.4746 27.4489 29.6917 27.3499L36.8501 24.1016Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3333 23.3333V28.3333",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 25.4167V28.3334C24 28.9965 24.5268 29.6323 25.4645 30.1012C26.4021 30.57 27.6739 30.8334 29 30.8334C30.3261 30.8334 31.5979 30.57 32.5355 30.1012C33.4732 29.6323 34 28.9965 34 28.3334V25.4167",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_468_10221",
    x: 0,
    y: 0,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_468_10221"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_468_10221"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_468_10221"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_468_10221",
    result: "effect2_dropShadow_468_10221"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_468_10221",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_468_10221",
    x1: 5,
    y1: 1,
    x2: 53,
    y2: 49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003D7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005BAC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_468_10221"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(19 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduate);
export default __webpack_public_path__ + "static/media/graduate.05d9fdac01501109d7b41313ab1d6843.svg";
export { ForwardRef as ReactComponent };